import { Component, inject, OnInit } from "@angular/core"

import { SnackbarService, FirebaseAuthService } from "@services"
import { PasswordRecoveryComponent } from "../password-recovery/password-recovery.component"

@Component({
  selector: "checkd-password-recovery-view",
  templateUrl: "./password-recovery-view.component.html",
  styleUrls: ["./password-recovery-view.component.scss"],
  imports: [PasswordRecoveryComponent],
})
export class PasswordRecoveryViewComponent implements OnInit {
  constructor(
    private readonly authService: FirebaseAuthService,
    private readonly snackbarService: SnackbarService,
  ) {}

  ngOnInit() {}

  onSubmit(email: string) {
    this.authService
      .sendPasswordResetEmail(email)
      .then((_) => {
        this.snackbarService.showMessage(`Password reset email sent to ${email}!`)
      })
      .catch((err) => {
        this.snackbarService.showMessage(`ERROR: ${err}`)
      })
  }
}
